import { HStack, Icon, Menu, MenuItem, MenuList, Spinner, Text } from "@chakra-ui/react";
import { FaFileExport } from "react-icons/fa";
import { ReportMenuButton } from "../../Shared/Components/ReportMenuButton";
import { reportToolbarStyles } from "../../Shared/Styles/reportToolbarStyles";

export function AnalyticalLayersActions({ isExporting, onExport, texts }) {
  return (
    <Menu>
      <ReportMenuButton>
        <HStack spacing={2}>
          {isExporting ? <Spinner size="xs" /> : <Icon as={FaFileExport} />}
          <Text>{texts.reports?.export || "Export"}</Text>
        </HStack>
      </ReportMenuButton>
      <MenuList {...reportToolbarStyles.menuList}>
        <MenuItem onClick={() => onExport("PDF")}>
          {texts.reports?.toPDF || "To PDF"}
        </MenuItem>
        <MenuItem onClick={() => onExport("Excel")}>
          {texts.reports?.toExcel || "To Excel"}
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
